export * from "./useUserStore";
export * from "./useAppTabsStore";
export * from "./useCollapsedStore";
export * from "./useUserRoleStore";

export const resetStores = () => {
	// 清理所有store数据
	const stores = import.meta.glob("./*.ts", { eager: true }) as AObject;

	Object.keys(stores).forEach((key) => {
		if (key === "./index.ts") {
			return;
		}

		const fileName = key.replace("./", "").replace(".ts", "");

		const storeKey = fileName.charAt(0).toLowerCase() + fileName.slice(1);

		const store = stores[key] as { [key: string]: () => { $reset: () => void } };

		if (store?.[storeKey]) {
			store[storeKey]().$reset();
		}
	});
};
